/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Bank Portal APIs
 * OpenAPI spec version: 0.1
 */

export type AnonymousProductPaginatedProperty =
  typeof AnonymousProductPaginatedProperty[keyof typeof AnonymousProductPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnonymousProductPaginatedProperty = {
  PRODUCT_TYPE: 'PRODUCT_TYPE',
  GROSS_RATE: 'GROSS_RATE',
  PERIOD: 'PERIOD',
} as const;
